import React, { useState, useEffect } from 'react';
import Borde from './components/Borde.js';
import './Services.css';
import icon1Img from './components/images/preg.png';
import icon2Img from './components/images/homeIcon.png';
import icon3Img from './components/images/Analysis.png';
import icon4Img from './components/images/sexicon.png';
import Footersection from './components/Footersection.js';

import { IoFilterCircleSharp } from "react-icons/io5";
import { useTranslation } from 'react-i18next';
import Slideshow from "./pages/Slideshow";
import Gorfe from './components/Gorfe.js';
import SerQuestion from './SerQuestion.js';
import { Link } from "react-router-dom";
import './components/Filters.css';
import Pill from "./Pill";

import icon5Img from './components/images/All_medicine.png';
import icon6Img from './components/images/Preventive_medicine.png';
import icon7Img from './components/images/Diagnostic_medicine.png';
import icon8Img from './components/images/Therapeutic_medicine.png';
import icon9Img from './components/images/Complementary_medicine.png';
import icon10Img from './components/images/Aesthetic_medicine.png';
import icon11Img from './components/images/Teenagers.png';
import icon12Img from './components/images/elderly.png';
import icon13Img from './components/images/children.png';
import icon14Img from './components/images/Newborn.png';
import icon15Img from './components/images/Adultes.png';

import icon16Img from './components/images/hospital.png';
import icon17Img from './components/images/Home_Services.png';
import icon18Img from './components/images/clinic.png';
import icon19Img from './components/images/Nursing_home.png';
import icon20Img from './components/images/Field_medicine.png';
import icon21Img from './components/images/Specialized_center.png';


import icon22Img from './components/images/Vaccinations.png';
import icon23Img from './components/images/Psychotherapy.png';
import icon24Img from './components/images/General_Surgery.png';
import icon25Img from './components/images/Binoculars.png';
import icon26Img from './components/images/Scouting.png';
import icon27Img from './components/images/Analysis.png';


import icon29Img from './components/images/Maternal_health.png';
import icon30Img from './components/images/Andrology.png';
import icon31Img from './components/images/Women_and_Obstetrics.png';
import icon32Img from './components/images/Fertility_medicine.png';




import icon33Img from './components/images/Skin_diseases.png';
import icon34Img from './components/images/Tumors.png';
import icon35Img from './components/images/cardiology.png';
import icon36Img from './components/images/Women_and_Obstetrics.png';
import icon37Img from './components/images/children.png';
import icon38Img from './components/images/Internal_Medicine.png';
import icon39Img from './components/images/Nouveaunes.png';
import icon40Img from './components/images/Physiotherapy.png';
import icon41Img from './components/images/feeding.png';
// import background from './components/images/78d165eb8db050f5d1a305ed1e6b9efe.jpg';







const Services = () => {
  const { t, i18n } = useTranslation("global");

  const [activeFilters, setActiveFilters] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [serviceData, setServiceData] = useState([]);
  const [originalServiceData, setOriginalServiceData] = useState([]);
  const [isMobileFilterVisible, setIsMobileFilterVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [visibleItems, setVisibleItems] = useState(15);
  const getActiveFiltersText = () => {
    const filterNames = Object.entries(activeFilters)
      .filter(([key, value]) => value)
      .map(([key, value]) => `${value}`);

    return filterNames.length > 0
      ? `التصفية المفعلة: ${filterNames.join(", ")}`
      : "لا توجد تصفية مفعلة حاليًا";
  };
  const sectionsData = [

    {
      title: "حدد التخصص",
      buttons: [
        // {
        //   label: "الأمراض الجلدية", icon:
        //     < img src={icon33Img} className="category-icon" />
        // },
        {
          label: "الأورام", icon:
            < img src={icon34Img} className="category-icon" />
        },
        {
          label: "طب القلب", icon:
            < img src={icon35Img} className="category-icon" />
        },
        {
          label: "النساء و التوليد", icon:
            < img src={icon36Img} className="category-icon" />
        },
        {
          label: "طب الأطفال", icon:
            < img src={icon37Img} className="category-icon" />
        },
        {
          label: "الأمراض الباطنية", icon:
            < img src={icon38Img} className="category-icon" />
        },
      ],
    }
  ];
  const getDirection = () => (i18n.language === "ar" ? "rtl" : "ltr");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchAndFilterData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchData();
        setOriginalServiceData(data);
        setServiceData(data);
      } catch (error) {
        setServiceData([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAndFilterData();
  }, []);

  const fetchData = async () => {
    const apiUrl = process.env.REACT_APP_URL7;
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  };

  const renderServiceData = () => {
    if (isLoading) {
      return (
        <div className="centrPi">
          <p className="centrPip">جاري تحميل البيانات...</p>
        </div>
      );
    }
    if (!serviceData.length) {
      return (
        <div className="centrPi">
          <p className="centrPip">لا توجد بيانات متاحة حاليًا. يرجى المحاولة لاحقًا.</p>
        </div>
      );
    }

    const visibleServiceData = serviceData.slice(0, visibleItems);
    const FiltreActivateNow = getActiveFiltersText(); // Get the active filters text

    return (
      <div>
        {/* Display active filters banner */}
        <div className="FiltreActivateBanner">
          <h2>{FiltreActivateNow}</h2>
        </div>

        {/* Desktop view */}
        <div className="desktop-view">
          {visibleServiceData.map((service, index) => (
            <div className="speed2desktopr" key={index}>
              <Link to={`/DetailsAdd?id=${service.service_id}`}>
                <img
                  className="speed4desktop"
                  src={service.image}
                  alt="Service Visual Representation"
                />
                <p className="speed45desktop">{service.title}</p>
              </Link>
              <SummaryWithToggle summary={service.summary} />
            </div>
          ))}
        </div>

        {/* Mobile view */}
        <div className="mobile-view">
          <div className="talej">
            {visibleServiceData.map((service, index) => (
              <div className="service-talej" key={index}>
                <div className="rowrukaya">
                  <h5 className="service-talejh5">
                    <Link to={`/DetailsAdd?id=${service.service_id}`}>
                      {service.title}
                    </Link>

                  </h5>

                  <Link to={`/DetailsAdd?id=${service.service_id}`}>
                    <img
                      src={service.image}
                      alt="Service Visual Representation"
                      className="talej-image"
                    />
                  </Link>
                </div>

                <div className="summary-row">
                  <SummaryWithToggle summary={service.summary} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <br />
        <br />
        <br />
        <div className="centre">
          {visibleItems < serviceData.length && (
            <button className="moreB" onClick={() => setVisibleItems(visibleItems + 15)}>
              المزيد
            </button>
          )}
        </div>
      </div>
    );
  };



  const categoriesLocalFilter = [
    { label: t('renderServiceData.label1'), value: "", icon: icon5Img },
    { label: t('renderServiceData.label2'), value: "وقاية", icon: icon6Img },
    { label: t('renderServiceData.label3'), value: "تشخيص", icon: icon7Img },
    { label: t('renderServiceData.label4'), value: "علاج", icon: icon8Img },
    { label: t('renderServiceData.label5'), value: "رعاية", icon: icon9Img },
    { label: t('renderServiceData.label6'), value: "تجميل", icon: icon10Img },
  ];

  return (
    <div className="servicescontainer" style={{ direction: getDirection() }}>
      {isMobile && (
        <button className="filter-btn-mobile" onClick={() => setIsMobileFilterVisible(!isMobileFilterVisible)}>
          <IoFilterCircleSharp />
        </button>
      )}

      <div className="whiteamene">
        <Borde />
        <nav className="categories-nav">
          <div className="categories-wrapper">
            {categoriesLocalFilter.map((category, index) => (
              <button
                key={index}
                className={`category-btn ${activeFilters.category === category.value ? "active" : ""}`}
                onClick={() => setActiveFilters({ ...activeFilters, category: category.value })}
              >
                <img src={category.icon} alt={`${category.label} icon`} className="category-icon" />
                {category.label}
              </button>
            ))}
          </div>
        </nav>
        <div className="main-layout">
          {!isMobile && (
            <div className="desktopV">
              <RedSection
                sectionsData={sectionsData}
                originalServiceData={originalServiceData}
                setServiceData={setServiceData}
                activeFilters={activeFilters}
                setActiveFilters={setActiveFilters}
                setIsMobileFilterVisible={setIsMobileFilterVisible}
                t={t} // Pass `t` here

              />
            </div>
          )}
          <div className={`mobile-filter-panel mobileV ${isMobileFilterVisible ? "visible" : ""}`}>
            <RedSection
              sectionsData={sectionsData}
              originalServiceData={originalServiceData}
              setServiceData={setServiceData}
              activeFilters={activeFilters}
              setActiveFilters={setActiveFilters}
              setIsMobileFilterVisible={setIsMobileFilterVisible}
              t={t} // Pass `t` here

            />
            <button className="close-filter-btn" onClick={() => setIsMobileFilterVisible(false)}>
              اغلاق
            </button>
          </div>
          <div className="blue-section">
            <div className="Contdeps">
              <h1 className="TitlrrContw">
                {t("services.Children")} ({serviceData.length})
              </h1>
              <div className="speed1">
                {isLoading ? <Pill /> : renderServiceData()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Slideshow />
      <Gorfe />
      <SerQuestion />
      <Footersection />
    </div>
  );
};

export default Services;


function SummaryWithToggle({ summary }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <p className="speed53desktop">
      {isExpanded ? summary : `${summary.slice(0, 180)}...`}
      {summary.length > 40 && (
        <span
          className="showMoreS"
          onClick={handleToggle}
          style={{ cursor: "pointer", color: "#5271ff" }}
        >
          {isExpanded ? " عرض أقل" : "المزيد"}
        </span>
      )}
    </p>
  );
}







const RedSection = ({
  sectionsData,
  originalServiceData,
  setServiceData,
  activeFilters,
  setActiveFilters,
  setIsMobileFilterVisible,
  t
}) => {
  const [expandedSections, setExpandedSections] = useState([]);

  const ageSection = {
    title: "حدد العمر",
    key: "ageSection",
    buttons: [
      {
        label: "الاجنه", key: "جنين", icon:
          <img src={icon14Img} className="category-icon" />
      },
      {
        label: "المواليد", key: "رضيع", icon:
          <img src={icon39Img} className="category-icon" />

      },
      {
        label: "الأطفال", key: "طفل", icon:
          <img src={icon13Img} className="category-icon" />
      },
      {
        label: "المراهقين", key: "مراهق", icon:
          <img src={icon11Img} className="category-icon" />
      },
      {
        label: "البالغين", key: "بالغ", icon:
          <img src={icon15Img} className="category-icon" />
      },

      {
        label: "الكبار", key: "كبار السن",
        icon:
          < img src={icon12Img} className="category-icon" />
      },
    ],
  };


  const serviceLocationSection = {
    title: "حدد نوع مزود الخدمة",
    key: "serviceLocationSection",
    buttons: [
      {
        label: "المستشفى", key: "في المستشفى", icon:

          < img src={icon16Img} className="category-icon" />
      },
      {
        label: "المنزل", key: "في المنزل", icon:
          < img src={icon17Img} className="category-icon" />
      },
      // {
      //   label: "المستوصف", key: "المستوصف", icon:
      //     < img src={icon18Img} className="category-icon" />
      // },
      // {
      //   label: "دار رعاية", key: "دار رعاية", icon:
      //     < img src={icon19Img} className="category-icon" />
      // },
      // {
      //   label: "الطب الميداني", key: "الطب الميداني", icon:
      //     < img src={icon20Img} className="category-icon" />
      // },
      // {
      //   label: "مركز تخصصي", key: "مركز تخصصي", icon:
      //     < img src={icon21Img} className="category-icon" />
      // },
    ],
  };



  const procedureSection = {
    title: t("renderServiceData.procedureTitle"),
    key: "procedureSection",
    buttons: [
      {
        label: t("renderServiceData.label7"), key: "التطعيمات", icon:
          <img src={icon22Img} className="category-icon" />
      },
      {
        label: t("renderServiceData.label8"), key: "العلاج النفسي", icon:
          <img src={icon23Img} className="category-icon" />
      },
      {
        label: t("renderServiceData.label9"), key: "جراحة عامة", icon:
          <img src={icon24Img} className="category-icon" />
      },
      {
        label: t("renderServiceData.label10"), key: "مناظير", icon:
          <img src={icon25Img} className="category-icon" />
      },
      {
        label: t("renderServiceData.label11"), key: "كشف", icon:
          <img src={icon26Img} className="category-icon" />
      },
      {
        label: t("renderServiceData.label12"), key: "تحاليل", icon:
          <img src={icon27Img} className="category-icon" />
      },
    ],
  };


  const problemSection = {
    title: "حدد المشكلة",
    key: "problemSection",
    buttons: [
      {
        label: "الصحة الجنسية", key: "الصحة الجنسية", icon:
          < img src={icon4Img} className="category-icon" />
      },
      // {
      //   label: "صحة الأمومة", key: "صحة الأمومة", icon:
      //     < img src={icon29Img} className="category-icon" />
      // },
      {
        label: "طب الذكورة", key: "طب الذكورة", icon:
          < img src={icon30Img} className="category-icon" />
      },
      // {
      //   label: "النساء و التوليد", key: "النساء و التوليد", icon:
      //     < img src={icon31Img} className="category-icon" />
      // },
      {
        label: "طب الخصوبة", key: "طب الخصوبة", icon:
          < img src={icon32Img} className="category-icon" />
      },
    ],
  };
  useEffect(() => {
    const filteredServices = originalServiceData.filter((service) => {
      if (!service.filters) return false;

      try {
        const serviceFilters = JSON.parse(service.filters);

        return Object.entries(activeFilters).every(([sectionKey, filterKey]) => {
          if (!filterKey) return true;
          return serviceFilters[sectionKey]?.includes(filterKey);
        });
      } catch (error) {
        return false;
      }
    });

    setServiceData(filteredServices);
  }, [activeFilters, originalServiceData, setServiceData]);
  const toggleExpand = (sectionKey) => {
    setExpandedSections((prevState) =>
      prevState.includes(sectionKey)
        ? prevState.filter((key) => key !== sectionKey)
        : [...prevState, sectionKey]
    );
  };


  const handleFilterClick = (sectionKey, filterKey) => {
    setActiveFilters((prevFilters) => ({
      ...prevFilters,
      [sectionKey]: prevFilters[sectionKey] === filterKey ? null : filterKey,
    }));
    setIsMobileFilterVisible(false);

  };
  useEffect(() => {
    const filteredServices = originalServiceData.filter((service) => {
      if (!service.filters && !service.Specialiste2 && !service.sections) return false;

      try {
        const parsedFilters = service.filters ? JSON.parse(service.filters) : {};
        const parsedSpecialiste2 = service.Specialiste2 ? JSON.parse(service.Specialiste2) : [];
        const parsedSections = service.sections ? JSON.parse(service.sections) : [];
        const titles = parsedSpecialiste2.map((item) => item.title);
        const matchesKeywords = (keywords, content) =>
          keywords.every((word) => content.includes(word));
        return Object.entries(activeFilters).every(([sectionKey, filterKey]) => {
          if (!filterKey) return true; // Skip if no filter is active for this section

          switch (sectionKey) {
            case "category":
              return service.filters?.includes(filterKey);

            case "ageSection":
              return parsedFilters.age_group?.includes(filterKey);

            case "serviceLocationSection":
              return parsedFilters.service_location?.includes(filterKey);

            case "specialitySection":
              if (filterKey === "الأمراض الجلدية") {
                return titles.includes("التجميل-الجراحي");
              } else if (filterKey === "الأورام") {
                return (
                  titles.includes("جراحة-الأورام") ||
                  titles.includes("العلاج-الإشعاعي") ||
                  titles.includes("العلاج-الكيميائي") ||
                  titles.includes("طب-الأورام-النسائية")
                );
              } else if (filterKey === "النساء و التوليد") {
                return (
                  titles.includes("طب-التوليد") ||
                  titles.includes("طب-الخصوبة") ||
                  titles.includes("تشخيص-وعلاج-الالتهابات-النسائية") ||
                  titles.includes("طب-الأورام-النسائية")
                );
              } else if (filterKey === "طب القلب") {
                return (
                  titles.includes("أمراض-القلب") ||
                  titles.includes("إعادة-التأهيل-القلبي") ||
                  titles.includes("جراحة-القلب-والصدر")
                );
              } else if (filterKey === "الصحة الجنسية") {
                return (
                  titles.includes("علاج-العقم") ||
                  titles.includes("طب-الخصوبة") ||
                  titles.includes("تنظيم-الأسرة") ||
                  titles.includes("تشخيص-وعلاج-الالتهابات-النسائية")
                );
              }
              return false;

            case "procedureSection": {
              const keywords = {
                التطعيمات: ["لقاح", "تحصينات", "وقاية"],
                "العلاج النفسي": ["علاج جماعي", "علاج نفسي", "النطق"],
                "جراحة عامة": ["جراحة"],
                مناظير: ["منظار"],
                كشف: [" استشاري ", " اخصائي ", "استشارة العلاج الوظيفي", "استشارة علاج طبيعي"
                  , "استشارة علاج طبيعي",
                  "استشارة النطق (Speech Consultation)"],
                تحاليل: ["تحليل"],
                "علاج طبيعي": ["علاج طبيعي"],
                "برامج تغذية": ["برنامج الحمية","برنامج متابعة"]
              };
              return parsedSections.some((section) =>
                keywords[filterKey]?.some((word) =>
                  section.title.includes(word) ||
                  section.content.some((text) => text.includes(word))
                )
              );
            }

            case "problemSection": {
              const problemKeywords = {
                "الصحة الجنسية": ["التناسلية", "الأمراض المنقولة جنسياً"],
                "صحة الأمومة": ["الحمل", "الأمومة"],
                "طب الذكورة": ["التناسلي", "الخصوبة"],
                "النساء والتوليد": ["جنين", "ولادة", "الحمل"],
                "طب الخصوبة": ["تلقيح", "إنجاب"],
              };

              const keywords = problemKeywords[filterKey];
              if (!keywords) return false;

              return parsedSections.some((section) =>
                matchesKeywords(keywords, section.title) ||
                matchesKeywords(keywords, section.content.join(" "))
              );
            }

            default:
              return false;
          }
        });
      } catch (error) {
        return false;
      }
    });

    setServiceData(filteredServices);
  }, [activeFilters, originalServiceData]);


  return (
    <div >
      <div className="red-title-section">
        <div className="titpart centre">
          <p>{t("renderServiceData.label18")}</p>
        </div>
        <div className="red-buttons-row">
          <Link to="/women_services" className="category-link">
            <button className="category-button">
              <span className="button-icon">
                <img src={icon1Img} alt="Hospital Logo" className="category-icon" />
              </span>
              <p className="category-text">{t("renderServiceData.label15")}</p>
            </button>
          </Link>

          {/* Procedure Section: تحاليل */}
          <button
            className={`category-button ${activeFilters.procedureSection === "تحاليل" ? "active" : ""
              }`}
            onClick={() => handleFilterClick("procedureSection", "تحاليل")}
          >
            <span className="button-icon">
              <img src={icon3Img} className="category-icon" />
            </span>
            <p className="category-text">{t("renderServiceData.label12")}</p>
          </button>

          {/* Location Filter: في المنزل */}
          <button
            className={`category-button ${activeFilters.serviceLocationSection === "في المنزل" ? "active" : ""
              }`}
            onClick={() => handleFilterClick("serviceLocationSection", "في المنزل")}
          >
            <span className="button-icon">
              <img src={icon2Img} className="category-icon" />
            </span>
            <p className="category-text">{t("renderServiceData.label17")}</p>
          </button>

          {/* Speciality Section: الصحة الجنسية */}
          <button
            className={`category-button ${activeFilters.specialitySection === "الصحة الجنسية" ? "active" : ""
              }`}
            onClick={() => handleFilterClick("specialitySection", "الصحة الجنسية")}
          >
            <span className="button-icon">
              <img src={icon4Img} className="category-icon" />
            </span>
            <p className="category-text">{t("renderServiceData.label16")}</p>
          </button>







          <button
            className={`category-button ${activeFilters.procedureSection === "كشف" ? "active" : ""
              }`}
            onClick={() => handleFilterClick("procedureSection", "كشف")}
          >
            <span className="button-icon">
              <img src={icon26Img} className="category-icon" />
            </span>
            <p className="category-text">{t("renderServiceData.label11")}</p>
          </button>





          <button
            className={`category-button ${activeFilters.procedureSection === "علاج طبيعي" ? "active" : ""
              }`}
            onClick={() => handleFilterClick("procedureSection", "علاج طبيعي")}
          >
            <span className="button-icon">
              <img src={icon40Img} className="category-icon" />
            </span>
            <p className="category-text">{t("renderServiceData.label13")}</p>
          </button>



          <button
            className={`category-button ${activeFilters.procedureSection === "العلاج النفسي" ? "active" : ""
              }`}
            onClick={() => handleFilterClick("procedureSection", "العلاج النفسي")}
          >
            <span className="button-icon">
              <img src={icon23Img} className="category-icon" />
            </span>
            <p className="category-text">{t("renderServiceData.label8")}</p>
          </button>




          <button
            className={`category-button ${activeFilters.procedureSection === "برامج تغذية" ? "active" : ""
              }`}
            onClick={() => handleFilterClick("procedureSection", "برامج تغذية")}
          >
            <span className="button-icon">
              <img src={icon41Img} className="category-icon" />
            </span>
            <p className="category-text">{t("renderServiceData.label19")}</p>
          </button>
        </div>
      </div>




      {sectionsData.map((section, index) => (
        <div key={index} className="red-title-section">

          <div className="titpart centre">
            <p>
              {section.title}
            </p>
          </div>
          <div className="red-buttons-row">
            {expandedSections.includes(index)
              ? section.buttons.map((button, i) => (
                <button
                  key={i}
                  className={`red-button ${activeFilters.specialitySection === button.label ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("specialitySection", button.label)}
                >
                  <span >{button.icon}</span>
                  <p className="category-text">

                    {button.label}
                  </p>
                </button>
              ))
              : section.buttons.slice(0, 4).map((button, i) => (
                <button
                  key={i}
                  className={`red-button ${activeFilters.specialitySection === button.label ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("specialitySection", button.label)}
                >
                  <span >{button.icon}</span>
                  <p className="category-text">
                    {button.label}
                  </p>
                </button>
              ))}
          </div>
          {procedureSection.buttons.length > 4 && (
            <button
              className="more-button"
              onClick={() => toggleExpand('procedureSection')}
            >
              {expandedSections.includes('procedureSection') ? "عرض أقل" : "عرض المزيد"}
            </button>
          )}


        </div>
      ))}





      <div className="red-title-section ">
        <div className="titpart centre">
          <p> {procedureSection.title}</p>
        </div>
        <div className="red-buttons-row">

          {procedureSection.buttons.map((button, i) => (
            <button
              key={i}
              className={`red-button ${activeFilters.procedureSection === button.key ? "active" : ""
                }`}
              onClick={() => handleFilterClick(procedureSection.key, button.key)}
            >
              <span className="button-icon">{button.icon}</span>
              <p className="category-text">
                {button.label}
              </p>
            </button>
          ))}
        </div>
        {procedureSection.buttons.length > 4 && (
          <button
            className="more-button"
            onClick={() => toggleExpand(3)}
          >
            {expandedSections.includes(3) ? "عرض أقل" : "عرض المزيد"}
          </button>
        )}

      </div>









      {/* 

      <div className="red-title-section ">
        <div className="titpart centre">
          <p> {serviceLocationSection.title}</p>
        </div>
        <div className="red-buttons-row">

          {serviceLocationSection.buttons.map((button, i) => (
            <button
              key={i}
              className={`red-button ${activeFilters.serviceLocationSection === button.key ? "active" : ""
                }`}
              onClick={() => handleFilterClick(serviceLocationSection.key, button.key)}
            >
              <span className="button-icon">{button.icon}</span>
              <p className="category-text">
                {button.label}
              </p>
            </button>
          ))}
        </div>
        {serviceLocationSection.buttons.length > 4 && (
          <button
            className="more-button"
            onClick={() => toggleExpand('serviceLocationSection')}
          >
            {expandedSections.includes('serviceLocationSection') ? "عرض أقل" : "عرض المزيد"}
          </button>
        )}

      </div> */}















      <div className="red-title-section ">
        <div className="titpart centre">
          <p> {ageSection.title}</p>
        </div>
        <div className="red-buttons-row">

          {ageSection.buttons.map((button, i) => (
            <button
              key={i}
              className={`red-button ${activeFilters.ageSection === button.key ? "active" : ""
                }`}
              onClick={() => handleFilterClick(ageSection.key, button.key)}
            >
              <span className="button-icon">{button.icon}</span>
              <p className="category-text">
                {button.label}
              </p>
            </button>
          ))}
        </div>
        {ageSection.buttons.length > 4 && (
          <button
            className="more-button"
            onClick={() => toggleExpand('ageSection')}
          >
            {expandedSections.includes('ageSection') ? "عرض أقل" : "عرض المزيد"}
          </button>
        )}

      </div>


















      <div className="red-title-section">
        <div className="titpart centre">
          <p>{problemSection.title}</p>
        </div>
        <div className="red-buttons-row">
          {problemSection.buttons.map((button, i) => (
            <button
              key={i}
              className={`red-button ${activeFilters.problemSection === button.key ? "active" : ""}`}
              onClick={() => handleFilterClick(problemSection.key, button.key)}
            >
              <span className="button-icon">{button.icon}</span>
              <p className="category-text">{button.label}</p>
            </button>
          ))}
        </div>
        {problemSection.buttons.length > 4 && (
          <button
            className="more-button"
            onClick={() => toggleExpand('problemSection')}
          >
            {expandedSections.includes('problemSection') ? "عرض أقل" : "عرض المزيد"}
          </button>
        )}
      </div>



    </div>
  );

};














































// import React from "react";
// import './Services.css'; // Import your CSS file

// import icon2Img from './components/images/uiElement.png'; // Dynamic image import

// const Services = () => {
//   return (
//     <div className="services-container">
//       {/* First Background (z-index: 0) */}
//       <div className="services-background-base"></div>
      
//       {/* Second Background (z-index: 1) */}
//       <div
//         className="services-background-overlay"
//         style={{
//           backgroundImage: `url(${icon2Img})`, // Dynamic image
//           backgroundSize: "cover",
//           backgroundRepeat: "no-repeat",
//           backgroundPosition: "center",
//         }}
//       >
//         {/* Add any content here if needed */}
//       </div>
//     </div>
//   );
// };

// export default Services;
